import { render, staticRenderFns } from "./ArchivePublicList.vue?vue&type=template&id=5cab678e&scoped=true"
import script from "./ArchivePublicList.vue?vue&type=script&lang=js"
export * from "./ArchivePublicList.vue?vue&type=script&lang=js"
import style0 from "./ArchivePublicList.vue?vue&type=style&index=0&id=5cab678e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab678e",
  null
  
)

export default component.exports